import { render, staticRenderFns } from "./ProductFilters.vue?vue&type=template&id=294bf3a0&scoped=true"
import script from "./ProductFilters.vue?vue&type=script&lang=js"
export * from "./ProductFilters.vue?vue&type=script&lang=js"
import style0 from "./ProductFilters.vue?vue&type=style&index=0&id=294bf3a0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294bf3a0",
  null
  
)

export default component.exports